import { useEffect } from "react";
import { motion } from "framer-motion";
import { MailCheck } from "lucide-react";
import { trackMetaEvent } from "../utils/metaPixel";

const ease = [0.22, 1, 0.36, 1];
const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease, delay }}>
    {children}
  </motion.div>
);

/* Zwischenseite nach der Anmeldung (Double-Opt-in-Hinweis).
   Reaching this page equals a successful signup -> Lead conversion for Meta. */
export default function EigentlichFastGeschafft() {
  useEffect(() => {
    // No-op unless the visitor accepted cookies and the pixel is loaded.
    trackMetaEvent("Lead");
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-[#FBEFC9] to-[#F4DFA6]" data-testid="fast-geschafft-page">
      <div className="flex flex-1 items-center justify-center px-6 py-20">
        <div className="mx-auto max-w-xl text-center">
          <Reveal>
            <p className="font-heading text-xs font-semibold uppercase tracking-[0.34em] text-[#8A4A2E]">LIMONATA Coaching</p>
          </Reveal>
          <Reveal delay={0.1}>
            <span className="mx-auto mt-8 flex h-16 w-16 items-center justify-center rounded-full bg-[#5C1D10] text-[#FFF2B0] shadow-[0_18px_50px_-18px_rgba(92,29,16,0.55)]">
              <MailCheck className="h-8 w-8" />
            </span>
          </Reveal>
          <Reveal delay={0.18}>
            <h1 className="mt-8 font-heading text-4xl font-black leading-tight text-[#5C1D10] sm:text-5xl" data-testid="fast-geschafft-headline">Fast geschafft!</h1>
          </Reveal>
          <Reveal delay={0.26}>
            <p className="mt-6 text-lg leading-relaxed text-[#5C1D10]/85" data-testid="fast-geschafft-text">
              Bitte schau als nächstes in Dein Postfach und bestätige noch kurz Deine E-Mail-Adresse.
            </p>
          </Reveal>
          <Reveal delay={0.34}>
            <div className="mt-10 rounded-xl border border-[#EBC479]/60 bg-[#FFFBEE]/70 p-6" data-testid="fast-geschafft-note">
              <p className="text-sm leading-relaxed text-[#5C1D10]/75">
                Wenn Du meinen Newsletter bereits abonniert hast, brauchst Du Deine E-Mail nicht mehr bestätigen. Du findest die Mail mit allen Infos zur Masterclass in wenigen Minuten in Deinem Postfach.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.42}>
            <p className="mt-6 text-sm text-[#8A4A2E]" data-testid="fast-geschafft-spam">
              Keine Mail da? Schau auch kurz in Deinen Spam-Ordner - manchmal versteckt sie sich dort.
            </p>
          </Reveal>
        </div>
      </div>
      <footer className="pb-8 text-center">
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 font-heading text-[11px] uppercase tracking-wider text-[#8A4A2E]">
          <a href="https://luisabergholz.com/impressum" target="_blank" rel="noopener noreferrer" data-testid="footer-impressum" className="transition-colors hover:text-[#5C1D10]">Impressum</a>
          <a href="https://luisabergholz.com/datenschutzerklaerung" target="_blank" rel="noopener noreferrer" data-testid="footer-datenschutz" className="transition-colors hover:text-[#5C1D10]">Datenschutz</a>
        </div>
      </footer>
    </div>
  );
}
